import React from 'react';
import { Button, Tooltip } from '@arco-design/web-react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = {
  es: { label: 'ES', flag: '🇲🇽', name: 'Español' },
  en: { label: 'EN', flag: '🇺🇸', name: 'English' },
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language?.startsWith('en') ? 'en' : 'es';
  const nextLang = currentLang === 'es' ? 'en' : 'es';
  const next = LANGUAGES[nextLang];

  const handleToggle = () => {
    i18n.changeLanguage(nextLang);
  };

  return (
    <Tooltip content={next.name}>
      <Button
        type="text"
        size="small"
        onClick={handleToggle}
        style={{ fontWeight: 600, fontSize: '13px', minWidth: '36px' }}
      >
        {LANGUAGES[currentLang].label}
      </Button>
    </Tooltip>
  );
};

export default LanguageSwitcher;
